import { IInitialState } from "./types";

export const initialState: IInitialState = {
  marathonAgreementById: {
    data: null,
    loading: false,
    error: null,
  },
  allMarathonAgreementById: {
    params: {
      page: 1,
      pageSize: 10,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  createMarathonAgreementById: {
    data: null,
    loading: false,
    error: null,
  },
  updateMarathonAgreementById: {
    data: null,
    loading: false,
    error: null,
  }
};